"use strict";
import React, { Component } from 'react';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import {NavLink, Link} from 'react-router-dom';
import UnitListItem from './UnitListItem';



class UnitRegistration extends Component {
    constructor(props)
    {
        super(props);

        this.fetchUnits = this.fetchUnits.bind(this);
        this.removeUnit = this.removeUnit.bind(this);
        this.registerUnits = this.registerUnits.bind(this);
        this.cancelSelection = this.cancelSelection.bind(this);
        this.updateSelectedUnits= this.updateSelectedUnits.bind(this);


        this.state = {
            user_details:this.props.user_details,
            access_token:this.props.access_token,
            all_units:[],
            selected_units:[],
            api_loading:false,
            api_loading_message:"",
            loading:false,
            reg_feedback:"",
            reg_occured:true,
            units_message: "",
            loaded_successfully:false,
            api_error_message:"",
            mode:0,
            server_changes_made:false

        }
    }

    removeUnit(unit)
      {
        console.log("about to remove ", unit.Code);
        let code = unit.Code;

         

          let currentSelection = this.state.selected_units.slice();
          let remaining_units = this.state.all_units.slice();


          for(let l= 0; l < this.state.selected_units.length; l++)
          {
            console.log("current point ", this.state.selected_units[l].Code );

            if(this.state.selected_units[l].Code === unit.Code)
            {
              console.log("inside if block");

              currentSelection.splice(l, 1);
              remaining_units.push({Code: unit.Code, Names: unit.Names});
              break;
            }
          }

          this.setState({all_units: remaining_units, selected_units: currentSelection, reg_occured:false});
      }


    updateSelectedUnits(event)
      {
        let code = event.target.value;

          let currentCode = "";
          let currentName = "";

          let currentSelection = this.state.selected_units.slice();
          let remaining_units = this.state.all_units.slice();


          for(let l= 0; l < this.state.all_units.length; l++)
          {
            if(this.state.all_units[l].Code === code)
            {
              console.log("curent unit", remaining_units[l] );
              console.log("selected un", code);
              currentCode = remaining_units[l].Code;
              currentName = remaining_units[l].Names;
              remaining_units.splice(l, 1);
              currentSelection.push({Code: currentCode, Names: currentName});
              break;
            }
          }

          this.setState({all_units: remaining_units, selected_units: currentSelection, reg_occured:false});
      }

      cancelSelection(code)
        {
            let currentCode = "";
            let currentName = "";

            let currentSelection = this.state.selected_units.slice();
            let remaining_units = this.state.all_units.slice();


            for(let l= 0; l < this.state.selected_units.length; l++)
            {
              if(this.state.selected_units[l].Code === code)
              {
                currentCode = currentSelection[l].Code;
                currentName = currentSelection[l].Names;
                currentSelection.splice(l, 1);
                remaining_units.push({Code: currentCode, Names: currentName});
                break;
              }
            }

            this.setState({all_units: remaining_units, selected_units: currentSelection, reg_occured:false});
        }


      registerUnits()
      {

                this.setState({loading:true});
                let _this = this;

                const url = this.props.base_url +"/student/registerunits";

                superagent
                .post(url)
                .send({admission_number:_this.props.student_details.core_details.AdmnNo,
                        year:_this.props.student_details.class_details.Year,
                        semester:_this.props.student_details.class_details.Semester,
                        subjects:_this.state.selected_units,
                        student_class:_this.props.student_details.core_details.class,
                        term_type :_this.props.student_details.class_details.term})
                .set('Accept', 'application/json')
                .set('Content-Type', 'application/json')
                .then(function(res){
                    //res.body, res.headers, res.status
                    let error = res.body.error;
                    console.log("Response", res.body);


                    if(!error)
                    {
                        console.log("Process", "successful loading");

                        _this.setState({reg_feedback:res.body.message, selected_units:[], reg_occured:true,loaded_successfully:true,loading:false, api_error_message:res.body.message,server_changes_made:true});

                    }
                    else
                    {
                        _this.setState({reg_feedback:res.body.message, reg_occured:true,loading:false, all_units:[],  units_message: res.body.message,loaded_successfully:false, api_error_message:res.body.message, server_changes_made:true});
                    }

                })
                .catch(function(err){

                    console.log("error response", err);
                    _this.setState({reg_feedback:err, reg_occured:true, loading:false, all_units:[],  loaded_successfully:false, api_error_message:err,server_changes_made:true});
                });

      }


  fetchUnits()
  {

            this.setState({loading:true});
            let _this = this;

            const url = this.props.base_url +"/student/getcurrentunits";

            superagent
            .post(url)
            .send({admission_number:_this.props.student_details.core_details.AdmnNo,
                    year:_this.props.student_details.class_details.Year,
                    semester:_this.props.student_details.class_details.Semester,
                    programme_code:_this.props.student_details.programme_details.Code})
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .then(function(res){
                //res.body, res.headers, res.status
                let error = res.body.error;
                console.log("Response", res.body);


                if(!error)
                {
                    console.log("Process", "successful loading");

                    _this.setState({all_units:res.body.subjects,loaded_successfully:true,loading:false, api_error_message:"",server_changes_made:true});

                }
                else
                {
                    _this.setState({loading:false, all_units:[],  units_message: res.body.message,loaded_successfully:false, api_error_message:res.body.message, server_changes_made:true});
                }

            })
            .catch(function(err){

                console.log("error response", err);
                _this.setState({loading:false, all_units:[],  loaded_successfully:false, api_error_message:err,server_changes_made:true});
            });

  }





  renderErrorMessage()
  {
    const _this = this;

      if(this.state.authentication_error && !this.state.loading)
      {
          return(
            <div className="loading-progress">
                <div className="error-message">
                    <p>{_this.state.api_error_message}</p>
                </div>
            </div>
          );
      }
      else
      {
        return null;
      }

  }

  renderRegistrationFeedback()
  {
    const _this = this;

      if(this.state.reg_occured && !this.state.loading )
      {
          return(
            <div className="loading-progress text-center">
                <div className="error-message">
                    <p>{_this.state.reg_feedback}</p>
                </div>
            </div>
          );
      }
      else
      {
        return null;
      }

  }

  renderLoadingProgress()
  {
    const _this = this;
      if(this.state.api_loading)
      {
          return(
            <div className="loading-progress text-center">
            <div >
                {_this.state.api_loading_message}
                <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
            </div>
        </div>

          );
      }
      else{
          return null;
      }
  }

  renderUnitsSelected()
  {
    const _this = this;

    if(this.state.selected_units.length > 0)
    {
      let units_list = _this.state.selected_units.map(unit =>
          {
          return (
                <UnitListItem key={unit.Code} unit = {unit}  removeUnit={_this.removeUnit} />
                  );
          });

          return (
            <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <h4>Units Selected</h4>

                    <table className="table">

                            <thead>
                                <tr>

                                    <th style ={{fontWeight: "bold"}}>Unit Code</th>
                                    <th style ={{fontWeight: "bold"}}>Unit Title</th>
                                    <th style ={{fontWeight: "bold"}}></th>
                                </tr>
                            </thead>
                            <tbody>
                            {units_list}
                            </tbody>
                    </table>

                    <button className="btn btn-primary btn-round" onClick={_this.registerUnits.bind(_this)}  onTap={_this.registerUnits.bind(_this)} > Submit <div className="ripple-container"></div></button>


            </div>
          );
    }


  }

  renderSubmitButton()
  {
    const _this = this;
      if(this.state.api_loading)
      {
          return(
            <div className="loading-progress">
            <div >
                {_this.state.api_loading_message}
                <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
            </div>
        </div>

          );
      }
      else{
          return null;
      }
  }

  renderSelectBox()
  {
    const _this = this;
    let all_units_options;

    if(_this.state.all_units.length > 0)
    {
        all_units_options = _this.state.all_units.map(unit =>
            {
            return (
                <option value = {unit.Code} >{ unit.Code} - {unit.Names}</option>
                    );
            });
    }
    else
    {
        all_units_options=null;
    }


      if(_this.state.all_units.length > 0)
      {
          return(
            <div className="col-lg-8 block-centered text-center">

                <select type="select" value = "0" className="select-box" onChange = {this.updateSelectedUnits.bind(_this)}>
                  <option value = "0" >Select Unit</option>
                  {all_units_options}
                </select>
            </div>);
      }
      else{
          return null;
      }
  }

  renderMessage()
  {
    const _this = this;

    if(this.state.all_units.length > 0)
    {
      return (<p className = "text-center full-width" style = {{paddingTop:"10px", paddingBottom:"10px"}}> Select Units you want to register from the select box below. Then submit </p>);
    }

    else {
      return (<p className = "text-center full-width" style = {{paddingTop:"10px", paddingBottom:"10px",  color:"red"}} >{this.state.units_message}</p>);
    }

  }

  componentWillMount()
  {
    this.fetchUnits();
  }






  render() {

    const _this=this;
    let main_content;




    if(this.state.loading)
    {
        return(
            <div >
                    Loading, Please wait......
                    <ReactLoading className="loading-progress" type="bars" color="#000" height="100px" width="120px"  />
                </div>
        );
    }

    return (
            <div className="row full-width">
                    <div className="col-lg-12 col-md-12">
                        <div className="card full-width">
                            <div className="card-body">
                                <div className="tab-content">
                                    <div className="tab-pane active" id="profile">
                                        <h4 className ="text-center">UNIT REGISTRATION ({_this.props.student_details.class_details.Year} ,  {_this.props.student_details.class_details.Semester} )</h4>
                                          {this.renderRegistrationFeedback()}
                                          {this.renderMessage()}

                                        <div className="row full-width col-lg-12 block-centered">
                                            {_this.renderSelectBox()}
                                        </div>
                                        {_this.renderUnitsSelected()}

                                        <div className="row full-width block-centered col-lg-12">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

            </div>





    );
  }
}

export default UnitRegistration;
